function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9845 2.83398C9.16453 2.83398 2.83203 9.18065 2.83203 17.0007C2.83203 24.8207 9.16453 31.1673 16.9845 31.1673C24.8187 31.1673 31.1654 24.8207 31.1654 17.0007C31.1654 9.18065 24.8187 2.83398 16.9845 2.83398ZM16.9987 28.334C10.737 28.334 5.66536 23.2623 5.66536 17.0007C5.66536 10.739 10.737 5.66732 16.9987 5.66732C23.2604 5.66732 28.332 10.739 28.332 17.0007C28.332 23.2623 23.2604 28.334 16.9987 28.334Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.707 9.91602H15.582V18.416L23.0195 22.8785L24.082 21.136L17.707 17.3535V9.91602Z"
});

function SvgAccessTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "3 3 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessTime);
export default __webpack_public_path__ + "static/media/accessTime.4fb95222.svg";
export { ForwardRef as ReactComponent };